'use strict';

import { isString, isNumber } from 'lodash';

export default function parseBoolean(value, defaultValue = false) {
    if (isNumber(value)) {
        return !!value;
    }

    if (isString(value)) {
        value = value.toLowerCase();

        if (value === 'false' || value === 'off' || value === '0' || value === '') {
            return false;
        }

        if (value === 'true' || value === 'on' || value === '1') {
            return true;
        }
    }

    return defaultValue;
}
